module.exports = __webpack_public_path__ + "static/media/menu.624b720a.svg";